<template>
  <widget-step-page
    :btn-next-disabled="isBtnNextDisabled"
    :btn-prev-disabled="false"
    :on-btn-prev-clicked="onBtnPrevClicked"
    :on-btn-next-clicked="onBtnNextClicked"
  >
    <template #content>
      <div class="px-4 pb-14 pt-4">
        <div class="d-flex flex-column">
          <span
            class="mb-2"
          >Выберите дату и время:</span>

          <template v-if="scheduleList.length > 0">
            <template v-for="schedule in scheduleList">
              <span
                class="mt-2"
                style="font-size: 16px; color: #2A3948"
              >{{ schedule.date }}</span>
              <v-chip-group
                v-model="localScheduleId"
                column
              >
                <v-chip
                  v-for="time in schedule.times"
                  :key="time.id"
                  :value="time.id"
                  :ripple="false"
                  outlined
                  text-color="#2A3948"
                  color="#2A3948"
                  class="x-chip"
                  active-class="x-chip__active"
                >
                  {{ time.time }}
                </v-chip>
              </v-chip-group>
            </template>
          </template>
          <template v-else>
            <span class="mb-3 x-font__primary primary--text">
              К сожалению, на данный момент нет доступного времени для записи.
              <br/>
              Попробуйте, пожалуйста, позже.
            </span>
          </template>

          <cumulative-info-panel
            class="mt-8"
          />
        </div>
      </div>
    </template>
  </widget-step-page>
</template>

<script>
import {isNullOrUndefined} from "@/plugins/object-helpers"
import WidgetStepPage from "@/components/page-template/WidgetStepPage.vue"
import {
  WIDGET_STEP__PATIENT_DATA,
  WIDGET_STEP__SELECT_SERVICE
} from "@/plugins/consts"
import {mapGetters} from "vuex"
import CumulativeInfoPanel from "@/components/panels/CumulativeInfoPanel.vue"

export default {
  components: {
    CumulativeInfoPanel,
    WidgetStepPage
  },
  data() {
    return {
      localScheduleId: null,
    }
  },
  computed: {
    ...mapGetters([
      'doctorId',
      'filialId',
      'serviceId',
      'scheduleId',
      'scheduleList'
    ]),
    isBtnNextDisabled() {
      return isNullOrUndefined(this.localScheduleId)
    }
  },
  async mounted() {
    await this.getScheduleByService()
    this.localScheduleId = this.scheduleId
  },
  methods: {
    onBtnPrevClicked() {
      this.$store.commit('setScheduleId', null)
      this.$emit('change-step', WIDGET_STEP__SELECT_SERVICE)
    },

    onBtnNextClicked() {
      if (this.isBtnNextDisabled) {
        return
      }

      if (!isNullOrUndefined(this.localScheduleId)) {
        this.$store.commit('setScheduleId', this.localScheduleId)
        this.$emit('change-step', WIDGET_STEP__PATIENT_DATA)
      }
    },

    /**
     * Получение расписания для выбранной услуги
     */
    async getScheduleByService() {
      this.$eventBus.$emit('show-overlay', true)
      await this.$axios
        .get(`${this.$backendLink}/widget/schedule-doctor-service-in-filial`, {
          params: {
            filialId: this.filialId,
            doctorId: this.doctorId,
            serviceId: this.serviceId,
          }
        })
        .then(response => {
          this.$store.commit('setScheduleList', response.data.dates)
        })
        .finally(() => {
          this.$eventBus.$emit('show-overlay', false)
        })
    }
  }
}
</script>

<style scoped>

</style>